"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ResourceFilterableCollection_1 = require("./ResourceFilterableCollection");
/**
 * Provides a collection of {@link IIriTemplateMapping} that can be filtered with relevant criteria.
 * @class
 */
class MappingsCollection extends ResourceFilterableCollection_1.default {
    /**
     * Initializes a new instance of the {@link MappingsCollection}
     * class with initial collections of mappings to filter.
     * @param {Iterable<IIriTemplateMapping>} [mappings] Initial collection of mappings to filter.
     */
    constructor(mappings) {
        super(mappings);
    }
    /**
     * Obtains a collection of mappings for a given variable name.
     * @param {string} variableName Variable name.
     * @returns {IMappingsCollection}
     */
    ofVariableName(variableName) {
        let result = this;
        if (typeof variableName === "string" && variableName.length > 0) {
            result = this.narrowFiltersWith("variable", variableName);
        }
        return result;
    }
    /**
     * Obtains a collection of mappings for a given predicate.
     * @param {string} property Predicate IRI.
     * @returns {IMappingsCollection}
     */
    ofProperty(property) {
        let result = this;
        if (typeof property === "string" && property.length > 0) {
            result = this.narrowFiltersWith("property", value => value.property.iri === property);
        }
        return result;
    }
    /** @inheritdoc */
    createInstance(items) {
        return new MappingsCollection(items);
    }
}
exports.default = MappingsCollection;
//# sourceMappingURL=MappingsCollection.js.map